import { NewBookingPageLink } from "app/AppRouter/links"
import { Img } from "ui-kit/components-branded/index"

interface TryAgainProps {
    onClickGoToPayment: (value: boolean) => void
    bookingAvailable?: boolean
    hashId?: string
}

export function TryAgain({ onClickGoToPayment, bookingAvailable, hashId }: TryAgainProps) {
    return (
        <div className="redesign-container">
            <div className="try-again__container">
                <section className="try-again">
                    <div>
                        <div className="try-again__headline">Запись и оплата</div>
                        <div className="try-again__text">
                            Завершите оплату или выберите другое время, если передумали.
                        </div>
                    </div>
                    <Img
                        className="try-again__card-illustration"
                        src="booking_try_again_illustration.svg"
                        alt="Иллюстрация с предложением попробовать снова"
                        width={296}
                        height={168}
                    />
                    <a
                        onClick={() => onClickGoToPayment(false)}
                        className="try-again__primary-button b-button transition-ease"
                    >
                        Перейти к оплате
                    </a>
                    {bookingAvailable && hashId && (
                        <NewBookingPageLink
                            hashId={hashId}
                            target="_blank"
                            className="border-radius-5 py-3 px-5 text-center b-button button--regular w-100 try-again__secondary-button transition-ease"
                        >
                            Выбрать другое время
                        </NewBookingPageLink>
                    )}
                </section>
            </div>
        </div>
    )
}
